import React from "react";
import PdfToImages from "../components/PdfToImages";
import ImagesToPdf from "../components/ImagesToPdf";

export default function ConversionPage() {
  return (
    <main style={{ maxWidth: 900, margin: "0 auto" }}>
      <h1>Conversion</h1>

      <PdfToImages />

      <hr style={{ margin: "24px 0" }} />

      <ImagesToPdf />
    </main>
  );
}
